/* CSS HEX */
export default [
    '#abc4abff',
    '#d06d87ff',
    '#4c89a6ff',
    '#db9a5aff',
    '#8a769aff',
    '#9ec0b1ff',
    '#db8e5dff',
    '#5d6689ff',
    '#f3e9c1ff',
    '#77754bff'
]
